import axios from "axios";
import { AdresseIP } from '../AdresseIP';

export class ParcoursService {
  constructor() {
   this.adresse = new AdresseIP()
   this.backendUrl ='/service/api/diplome/authentification/liste-parcours'
   this.API_URL = this.adresse.getAdresseIP()+this.backendUrl
  }
  getParcoursByDepartement = async (idDepartement) => {
  const response = await axios.get(`${this.API_URL}?idDepartement=${idDepartement}`);
  return response.data;
};

}